import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Loader2, Ruler } from "lucide-react";
import { toast } from "sonner";

const FIELDS = [
  ["height", "Altezza"], ["bust", "Circonferenza seno"], ["waist_narrow", "Vita nel punto più stretto"],
  ["waist_button", "Vita dove abbottona"], ["hips", "Bacino a livello glutei"],
];

export const CustomerMeasurements = ({ id, value }) => {
  const qc = useQueryClient();
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => { setForm(value || {}); }, [value, id]);
  const save = async () => {
    setSaving(true);
    try {
      const body = Object.fromEntries(FIELDS.map(([k]) => [k, form[k] === "" || form[k] == null ? null : Number(form[k])]));
      await api.put(`/customers/${id}/measurements`, { ...body, notes: form.notes || null });
      toast.success("Misure salvate");
      qc.invalidateQueries({ queryKey: ["customer", id] });
      qc.invalidateQueries({ queryKey: ["customers"] });
      qc.invalidateQueries({ queryKey: ["activity-entity"] });
    } catch (e) { toast.error(e?.response?.data?.detail || "Salvataggio non riuscito"); }
    setSaving(false);
  };
  return (
    <div className="rounded-md border border-border/60 p-4" data-testid="customer-measurements">
      <p className="mb-3 flex items-center gap-1.5 text-[11px] uppercase tracking-widest text-muted-foreground">
        <Ruler className="h-3.5 w-3.5 text-primary" />Misure del corpo (cm)
      </p>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {FIELDS.map(([k, l]) => (
          <label key={k} className="text-xs text-muted-foreground">
            {l}
            <Input type="number" min="1" max="300" step="0.5" value={form[k] ?? ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })}
              className="mt-1" data-testid={`measure-${k}`} />
          </label>
        ))}
      </div>
      <label className="mt-3 block text-xs text-muted-foreground">
        Note per l'assistenza
        <Textarea value={form.notes || ""} onChange={(e) => setForm({ ...form, notes: e.target.value })} rows={2} className="mt-1" data-testid="measure-notes" />
      </label>
      <div className="mt-3 flex items-center justify-between gap-2">
        <span className="text-[11px] text-muted-foreground" data-testid="measure-updated">
          {value?.updated_at ? `Aggiornate il ${new Date(value.updated_at).toLocaleDateString("it-IT")}${value.updated_by ? ` da ${value.updated_by}` : ""}` : "Nessuna misura inserita"}
        </span>
        <Button size="sm" onClick={save} disabled={saving} data-testid="measure-save">
          {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Salva misure
        </Button>
      </div>
    </div>
  );
};
